import { render, staticRenderFns } from "./adwords.vue?vue&type=template&id=55201ca5&scoped=true"
import script from "./adwords.vue?vue&type=script&lang=js"
export * from "./adwords.vue?vue&type=script&lang=js"
import style0 from "./adwords.vue?vue&type=style&index=0&id=55201ca5&prod&lang=scss"
import style1 from "./adwords.vue?vue&type=style&index=1&id=55201ca5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55201ca5",
  null
  
)

export default component.exports